import { routeV1 } from "../pages/(v1)/route.v1";

const path = {
  satellite_system: "satellite_system",
  satellite_mounted_device: "satellite_mounted_device",
  civilian_device: "civilian_device",
  sarImage: "sar_image_processing",
  ai: "ai_based_object_detection",
  disaster: "disaster_damage_analysis",
  monitoring: "monitoring_urban_change",
  water_facility: "manage_water_facility_safety",
};

export const menus = [
  // 사업소개
  {
    title: "MENU_2",
    originLink: routeV1.products,
    link: routeV1.products,
    exposure: true,
    subMenus2: [
      {
        title: "MENU_2_6",
        link: `${routeV1.products}#${path.satellite_system}`,
        subMenus3: [],
        exposure: true,
      },
      {
        title: "MENU_2_7",
        link: `${routeV1.products}#${path.satellite_mounted_device}`,
        subMenus3: [],
        exposure: true,
      },
      {
        title: "MENU_2_9",
        link: `${routeV1.products}#${path.civilian_device}`,
        subMenus3: [],
        exposure: true,
      },
    ],
  },

  // 서비스
  {
    title: "MENU_6",
    originLink: routeV1.service,
    link: routeV1.service,
    exposure: true,
    subMenus2: [
      {
        title: "MENU_6_1",
        link: `${routeV1.service}#${path.sarImage}`,
        exposure: true,
        subMenus3: [],
      },
      {
        title: "MENU_6_2",
        link: `${routeV1.service}#${path.ai}`,
        exposure: true,
        subMenus3: [],
      },
      {
        title: "MENU_6_3",
        link: `${routeV1.service}#${path.disaster}`,
        exposure: true,
        subMenus3: [],
      },
      {
        title: "MENU_6_4",
        link: `${routeV1.service}#${path.monitoring}`,
        exposure: true,
        subMenus3: [],
      },
      {
        title: "MENU_6_5",
        link: `${routeV1.service}#${path.water_facility}`,
        exposure: true,
        subMenus3: [],
      },
    ],
  },

  // 회사 소개
  {
    title: "MENU_1",
    originLink: routeV1.introduce,
    link: routeV1.overview,
    exposure: true,
    subMenus2: [
      {
        title: "MENU_1_1",
        link: routeV1.overview,
        subMenus3: [],
        exposure: true,
      },
      {
        title: "MENU_1_2",
        link: routeV1.history,
        subMenus3: [],
        exposure: true,
      },
      {
        title: "MENU_1_3",
        link: routeV1.heritage,
        exposure: true,
        subMenus3: [],
      },
      {
        title: "MENU_1_4",
        link: routeV1.workspace,
        subMenus3: [],
        exposure: true,
      },
      {
        title: "MENU_1_5",
        link: routeV1.direction,
        subMenus3: [],
        exposure: true,
      },
    ],
  },

  // 투자정보
  {
    title: "MENU_3",
    originLink: routeV1.investment,
    link: routeV1.electronicAnnounce,
    exposure: true,
    subMenus2: [
      {
        title: "MENU_3_1_5",
        link: routeV1.electronicAnnounce,
        subMenus3: [],
        exposure: true,
      },
      {
        title: "MENU_3_1_6",
        link: `${routeV1.ir_info}/1`,
        subMenus3: [],
        exposure: true,
      },
      {
        title: "MENU_3_1",
        link: `${routeV1.managementInfo}/1`,
        subMenus3: [],
        exposure: true,
      },
    ],
  },

  // 사이버 홍보
  {
    title: "MENU_4",
    originLink: routeV1.cyber_relation,
    link: `${routeV1.newArticle}/1`,
    exposure: true,
    subMenus2: [
      {
        title: "MENU_4_1",
        link: `${routeV1.newArticle}/1`,
        subMenus3: [],
        exposure: true,
      },
      {
        title: "MENU_4_2",
        link: `${routeV1.lumirNews}/1`,
        subMenus3: [],
        exposure: true,
      },
      {
        title: "MENU_4_3",
        link: routeV1.videoGallery,
        originLink: routeV1.publicRelationsOffice,
        exposure: true,
        subMenus3: [
          {
            title: "MENU_4_3_1",
            link: routeV1.videoGallery,
            subMenus4: [],
            exposure: true,
          },
          {
            title: "MENU_4_3_2",
            link: `${routeV1.brochure}/1`,
            subMenus4: [],
            exposure: true,
          },
        ],
      },
    ],
  },

  //채용 홍보
  {
    title: "MENU_5",
    originLink: routeV1.recruit,
    link: routeV1.talentType,
    exposure: true,
    subMenus2: [
      {
        title: "MENU_5_1",
        link: routeV1.talentType,
        subMenus3: [],
        exposure: true,
      },
      {
        title: "MENU_5_4",
        link: `${routeV1.jobAnnounce}/1`,
        subMenus3: [],
        exposure: true,
      },
    ],
  },
];
